import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../../DataProviders/AppStateProvider';
import { useNavigation } from '../../Handler/NavigationHandler';

const AnswerButton = ({ children, answer, journey, nextStep }) => {
  const { appData, updateAppData } = useContext(AppContext);
  const { handleStepClick, getNextStep } = useNavigation();

  // Add state to manage when to trigger click
  const [shouldClick, setShouldClick] = useState(false);
  const [nextStepKey, setNextStepKey] = useState(null);

  const handleButtonClick = (e) => {
    e.preventDefault();

    let newNextStepKey;
    if (journey && typeof journey === 'string') {
      newNextStepKey = Object.keys(appData.journeys[journey])[0];
      updateAppData({
        [`journeys.${appData.currentJourney}.${appData.currentStep}.finished`]: true,
        [`journeys.${appData.currentJourney}.${appData.currentStep}.answer`]: answer,
        'currentJourney': journey,
        'currentStep': newNextStepKey
      });
    } else if (nextStep && typeof nextStep === 'string') {
      newNextStepKey = nextStep;
      updateAppData({
        [`journeys.${appData.currentJourney}.${appData.currentStep}.finished`]: true,
        [`journeys.${appData.currentJourney}.${appData.currentStep}.answer`]: answer,
        'currentStep': newNextStepKey
      });
    } else {
      newNextStepKey = getNextStep();
      updateAppData({
        [`journeys.${appData.currentJourney}.${appData.currentStep}.finished`]: true,
        [`journeys.${appData.currentJourney}.${appData.currentStep}.answer`]: answer,
        'currentStep': newNextStepKey
      });
    }

    if (newNextStepKey) {
      setNextStepKey(newNextStepKey);
      setShouldClick(true);
    }
  }

  useEffect(() => {
    if (shouldClick && nextStepKey) {
      handleStepClick(nextStepKey);
      setShouldClick(false); // reset the shouldClick state
    }
  }, [shouldClick, nextStepKey]);

  return (
    <a className="button button--secondary button--secondary-quickcheck-transparent" href="#" onClick={handleButtonClick}>
      <span className="button__text">{children}</span>
    </a>
  );
}

export default AnswerButton;
